import { Component, ViewChild, TemplateRef } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { HttpEventType } from "@angular/common/http";
import Swal from "sweetalert2";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { FormatosService } from "../../../../shared/services/formatos.service";
import { DigitalesService } from "../../../../shared/services/digitales.service";
import { DigitalesPesv, DigitalesPesvService } from "../../../../shared/services/digitales-pesv.service";
import { AdministracionService } from "../../../../shared/services/administracion.services";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AuthService } from "../../../../shared/services/auth.service";
import { PoliticaPesvService } from "../../../../shared/services/politicaPesv.service";
import { ImplementacionService } from "../../../../shared/services/implementacion.service";
import { NombreDocumentosService } from "../../../../shared/services/nombre-documentos.service";
import { VersionesDocumentoService } from "../../../../shared/services/versiones-documento.service";
import { environment } from "../../../../../environments/environment";
import { Subject, forkJoin, takeUntil } from "rxjs";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { EstadosDocumentoService } from "../../../../shared/services/estados-documento.service";
import { GoogleStoragePreviewService } from "../../../../shared/services/google-storage-preview.service";
import { gpcGoogleService } from "../../../../shared/services/gpcGoogle.service";

function normalize(str: any) {
  return str
    ? str
        .toString()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\s+/g, " ")
        .trim()
    : "";
}

interface ArchivoPesvCard {
  id: number;
  nombre: string;
  prefijo: string;
  file: File | null;
  formatos?: string[];
  formatosLabel?: string;
}

@Component({
  selector: 'app-politica-seguridad-vial',
  templateUrl: './politica-seguridad-vial.component.html',
  styleUrls: ['./politica-seguridad-vial.component.scss']
})
export class PoliticaSeguridadVialComponent {
  readonly PUNTO_POLITICA = 4;
  readonly NOMBRE_DOCUMENTO_POLITICA_ID = 4;

  formPolitica!: FormGroup;
  formEditarPolitica!: FormGroup;
  modalEditarPoliticaRef: any;
  cargando = false;
  cargandoHistorial = false;
  cargandoEditarPolitica = false;
  pdfUrl: SafeResourceUrl | null = null;
  @ViewChild('modalVisualizarPolitica') modalVisualizarPolitica!: TemplateRef<any>;
  @ViewChild('modalCrearPolitica')
  modalCrearPolitica!: TemplateRef<any>;
  modalCrearPoliticaRef!: NgbModalRef;
  frmPoliticaPesv!:FormGroup;
  historialPoliticas: any[] = [];
  nombreDocumentoPoliticaActivo: any | null = null;
  maestroPoliticaActivo: any | null = null;
  usuarioLogin: any;
  tabActivo: number = 1;
  page1: number = 1;
  pageSize1: number = 10;
  searchTextHistorialPolitica = "";
  private formatoPoliticaId = 3;
  descargandoPolitica = false;
  private vistaPreviaPolitica = false;
  private descargaPoliticaCancel$ = new Subject<void>();
  // Helpers para descargas/versiones (compatibilidad con Implementación)
  descargaActivaSub: any = null;
  descargaCancelada: boolean = false;
  versionPreview: boolean = false;
  // Algunos métodos/propiedades que usan las utilidades de versión
  formData: any = {};
  documento_id: any = null;
  tiposDocumentales: any[] = [];
  // Datos temporales de versión (compatibilidad con lógica de versiones)
  versionData: any = {};
  politicaEditandoId: number | string | null = null;
  politicaEditando: any = null;
  politicaCodigoOriginal: string | null = null;
  fechaDesignacionMax = "";
  fechaVencimientoMin = "";
  
  // Propiedades para carga de documentos
  archivoSeleccionado: File | null = null;
  archivoSeleccionadoEditar: File | null = null;
  archivoDigitalPolitica: ArchivoPesvCard = {
    id: 3,
    nombre: "Politica de Seguridad Vial",
    prefijo: "POLITICA",
    file: null,
    formatos: ["pdf", "doc", "docx"],
    formatosLabel: "pdf/doc/docx",
  };
  configuracionDigitalPolitica: DigitalesPesv | null = null;
  formatosPermitidosPolitica: string[] = ["pdf", "doc", "docx"];
  subiendoArchivo = false;
  progresoSubida = 0;
  mensajeSubida = "";
  estadoSubida: "" | "subiendo" | "exito" | "error" = "";
  administraciones: Administracion[] = [];
  empresaNit: string | null = null;
  nombreDocumentoSeleccionadoId: number | null = null;
  documentoDefaultPesv: any | null = null;
  nombreDocumentos: any[] = []
  pdfFileSelected: File | null = null; // Archivo PDF seleccionado
  estadosPolitica: any[] = [];
  hoy: string = '';

  get tienePoliticaVigente(): boolean {
    return (this.historialPoliticas || []).some((politica) => this.esPoliticaVigente(politica));
  }

  constructor(
    private formatosService: FormatosService,
    private digitalesService: DigitalesService,
    private digitalesPesvService: DigitalesPesvService,
    private politicaPesvService: PoliticaPesvService,
    private implementacionService: ImplementacionService,
    private nombreDocumentosService: NombreDocumentosService,
    private versionesDocumentoService: VersionesDocumentoService,
    private administracionesService: AdministracionService,
    private authService: AuthService,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private estadoDocumentosService:EstadosDocumentoService,
    private gpcGoogle: gpcGoogleService,
    private googleStoragePreview: GoogleStoragePreviewService,
  ) {}

  ngOnInit() {
    this.formPolitica = this.fb.group({
      codigo: ["", Validators.required],
      fecha_designacion: ["", Validators.required],
      fecha_vencimiento: ["", Validators.required],
    });

    this.formEditarPolitica = this.fb.group({
      codigo: ["", Validators.required],
      fecha_designacion: ["", Validators.required],
      fecha_vencimiento: ["", Validators.required],
      estado: [1, Validators.required],
    });

     this.frmPoliticaPesv = this.fb.group({
      codigo: ['', Validators.required],
      version: ['1.0', Validators.required],
      fecha_designacion: ['', Validators.required],
      fecha_vencimiento: ['', Validators.required],
      estado: [1, Validators.required],
      motivo_creacion: ['', Validators.required],
      soporte: [null, Validators.required]
    });


    this.usuarioLogin = this.authService.getCurrentUserValue();
  //  console.log('🔍 Usuario Login completo:', this.usuarioLogin.usuario);
  //  this.inicializarFechasPolitica();
    this.cargarNitEmpresa();
   // this.cargarConfiguracionDocumentoPolitica();
   this.cargarHistorialPoliticas();
  //  this.cargarDocumentoDefaultPesv();

  this.getEstadoDocumento();

  this.frmPoliticaPesv.get('fecha_designacion')?.valueChanges.subscribe(fecha => {

    if (fecha) {

      const fechaVencimiento = new Date(fecha);

      fechaVencimiento.setFullYear(
        fechaVencimiento.getFullYear() + 3
      );

      this.frmPoliticaPesv.patchValue({
        fecha_vencimiento: fechaVencimiento.toISOString().split('T')[0]
      });

    }

  });
  const today = new Date();
  this.hoy = today.toISOString().split('T')[0]; // YYYY-MM-DD
  }

  
 

  // ✅ Cargar NIT de la empresa para usar en descargas y subidas a Digitales PESV
  private cargarNitEmpresa(): void {
    this.administracionesService.obtenerTodas().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res) ? res : Array.isArray(res?.administraciones) ? res.administraciones : [];
        if (lista.length > 0) {
          this.empresaNit = lista[0].nit?.toString() || null;
         // console.log('🏢 NIT de la empresa cargado:', this.empresaNit);
        }
      },
      error: (err: any) => {
        console.error('❌ Error al cargar NIT de la empresa:', err);
      },
    });
  }

  private inicializarFechasPolitica(): void {
    const hoy = new Date();
    this.fechaDesignacionMax = this.formatearFechaParaInput(hoy);
    this.fechaVencimientoMin = "";
  }

  private formatearFechaParaInput(fecha: Date): string {
    const año = fecha.getFullYear();
    const mes = String(fecha.getMonth() + 1).padStart(2, "0");
    const día = String(fecha.getDate()).padStart(2, "0");
    return `${año}-${mes}-${día}`;
  }

  private normalizarFechaParaInput(fecha: any): string {
    if (!fecha) {
      return "";
    }

    const valor = String(fecha);
    if (/^\d{4}-\d{2}-\d{2}$/.test(valor)) {
      return valor;
    }

    const d = new Date(fecha);
    if (Number.isNaN(d.getTime())) {
      return "";
    }

    return this.formatearFechaParaInput(d);
  }

  private sumarUnAño(fecha: string): string {
    if (!fecha) {
      return "";
    }

    const base = new Date(`${fecha}T00:00:00`);
    if (Number.isNaN(base.getTime())) {
      return "";
    }

    base.setFullYear(base.getFullYear() + 1);
    return this.formatearFechaParaInput(base);
  }

  onFechaDesignacionChange(): void {
    const fechaDesignacion = String(this.formPolitica.get("fecha_designacion")?.value || "").trim();
    if (!fechaDesignacion) {
      this.fechaVencimientoMin = "";
      this.formPolitica.get("fecha_vencimiento")?.reset();
      return;
    }

    const fechaVencimiento = this.sumarUnAño(fechaDesignacion);
    this.fechaVencimientoMin = fechaVencimiento;
    if (!this.formPolitica.get("fecha_vencimiento")?.value) {
      this.formPolitica.get("fecha_vencimiento")?.setValue(fechaVencimiento);
    }
  }

  private obtenerCarpetaDigitalPolitica(): string {
    const prefijo = this.configuracionDigitalPolitica?.siglas || this.archivoDigitalPolitica.prefijo || 'PSV';
    // ✅ Incluir NIT administrativo en la ruta de descarga
    const nit = this.empresaNit || 'nit';
    return `${nit}/pesv/${prefijo}`;
  }

  private obtenerCarpetaCargadosPolitica(): string {
    const prefijo = this.configuracionDigitalPolitica?.siglas || this.archivoDigitalPolitica.prefijo || 'PSV';
    return `${prefijo}`;
  }

  private construirNombreDescargaPolitica(nombreOriginal?: string): string {
    return `DOCUMENTO POLITCA SEGURIDAD VIAL.pdf`;
  }

  get acceptDocumentoPolitica(): string {
    if (!this.formatosPermitidosPolitica.length) {
      return ".pdf,.doc,.docx";
    }
    return this.formatosPermitidosPolitica.map((f) => `.${f}`).join(",");
  }

  get formatosPermitidosPoliticaTexto(): string {
    return this.formatosPermitidosPolitica.map((f) => `.${f}`).join(", ");
  }



  descargarPolitica() {
    const formatoId = 3;
    const datos = {};
    
    this.cargando = true;
    this.formatosService.generarDocumento(formatoId, datos).subscribe({
      next: (blob: Blob) => {
        this.cargando = false;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Politica_Seguridad_Vial_${new Date().getTime()}.pdf`;
        link.click();
        window.URL.revokeObjectURL(url);
        Swal.fire('Éxito', 'Política descargada correctamente', 'success');
      },
      error: (err) => {
        this.cargando = false;
        Swal.fire('Error', this.obtenerMensajeError(err, 'No se pudo descargar la política'), 'error');
        console.error('Error al descargar PDF:', err);
      }
    });
  }

  formatDateTodo(fecha: any): string {
    if (!fecha) return "N/A";
    const d = new Date(fecha);
    return `${String(d.getUTCDate()).padStart(2, "0")}/${String(
      d.getUTCMonth() + 1
    ).padStart(2, "0")}/${d.getUTCFullYear()}`;
  }

  onTabChange(event: any): void {
    this.tabActivo = event.nextId;
  }

  descargarPoliticaDirecta(event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    const politica = this.historialPoliticasVista?.[0];
    if (!politica) {
      Swal.fire("Info", "No hay política registrada para descargar.", "info");
      return;
    }
  //  this.descargarDesdeHistorialPolitica(politica);
  }

  get historialPoliticasVista(): any[] {
    const base = this.historialPoliticas || [];
    const search = normalize(this.searchTextHistorialPolitica);

    if (!search) {
      return base;
    }

    return base.filter((item: any) => {
      const codigo = normalize(item?.codigo || "");
      const nombre = normalize(item?.nombre || "");
      const fechaDesignacion = normalize(this.formatDateTodo(item?.fecha_designacion));
      const fechaVencimiento = normalize(this.formatDateTodo(item?.fecha_vencimiento));
      const estado = this.esPoliticaActiva(item) ? "activa" : "inactiva";
      return (
        codigo.includes(search) ||
        nombre.includes(search) ||
        fechaDesignacion.includes(search) ||
        fechaVencimiento.includes(search) ||
        estado.includes(search)
      );
    });
  }

  aplicarFiltroHistorialPolitica(): void {
    this.page1 = 1;
  }

  exportarHistorialPoliticaExcel(): void {
    const datos = this.historialPoliticasVista || [];
    if (!datos.length) {
      this.mostrarSwalAccion("info", "Sin datos", "No hay políticas para exportar");
      return;
    }

    const filas = datos.map((item: any) => ({
      CODIGO: item?.codigo || "",
      DESIGNACION: this.formatDateTodo(item?.fecha_designacion),
      VENCIMIENTO: this.formatDateTodo(item?.fecha_vencimiento),
      ESTADO: this.esPoliticaActiva(item) ? "ACTIVA" : "INACTIVA",
    }));

    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Politicas");
    XLSX.writeFile(wb, `historial_politicas_${Date.now()}.xlsx`);
    this.mostrarSwalAccion("success", "Exito", "Exportacion a Excel completada");
  }

  exportarHistorialPoliticaPdf(): void {
    const datos = this.historialPoliticasVista || [];
    if (!datos.length) {
      this.mostrarSwalAccion("info", "Sin datos", "No hay políticas para exportar");
      return;
    }

    const doc = new jsPDF("p", "pt");
    doc.setFontSize(12);
    doc.text("Historial de Politicas de Seguridad Vial", 40, 35);

    autoTable(doc, {
      head: [["CODIGO", "DESIGNACION", "VENCIMIENTO", "ESTADO"]],
      body: datos.map((item: any) => [
        item?.codigo || "",
        this.formatDateTodo(item?.fecha_designacion),
        this.formatDateTodo(item?.fecha_vencimiento),
        this.esPoliticaActiva(item) ? "ACTIVA" : "INACTIVA",
      ]),
      startY: 50,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [13, 110, 253] },
    });

    doc.save(`historial_politicas_${Date.now()}.pdf`);
    this.mostrarSwalAccion("success", "Exito", "Exportacion a PDF completada");
  }

 /*  descargarDesdeHistorialPolitica(item: any, previsualizar: boolean = false): void {
    if (this.descargandoPolitica) {
      return;
    }

    Swal.fire({
      title: previsualizar ? "Confirmar previsualización" : "Confirmar descarga",
      text: previsualizar ? "¿Deseas abrir esta politica en otra pestaña?" : "Deseas descargar esta politica?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: previsualizar ? "Si, previsualizar" : "Si, descargar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#0d6efd",
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.vistaPreviaPolitica = previsualizar;
      this.descargandoPolitica = true;
      this.descargaPoliticaCancel$ = new Subject<void>();

      const finalizarDescarga = () => {
        this.descargandoPolitica = false;
        this.descargaPoliticaCancel$.next();
        this.descargaPoliticaCancel$.complete();
        this.descargaPoliticaCancel$ = new Subject<void>();
        Swal.close();
      };

      Swal.fire({
        title: previsualizar ? "Abriendo vista previa..." : "Descargando...",
        text: previsualizar ? "Espera mientras se abre el documento" : "Espera mientras se descarga el documento",
        allowOutsideClick: false,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          finalizarDescarga();
        }
      });

      const finalizarYSalir = () => {
        finalizarDescarga();
        this.vistaPreviaPolitica = false;
      };

      if (item?.esVersionMaestro) {
      //  this.descargarVersionDesdeMaestroActivo(item, finalizarYSalir, previsualizar);
        return;
      }

      if (item?.codigo) {
     //   this.descargarDocumentoPoliticaPorCodigo(item, finalizarYSalir, previsualizar);
        return;
      }

    //  this.descargarDocumentoPoliticaPorDefecto(finalizarYSalir, previsualizar);
    });
  } */

/*   visualizarDesdeHistorialPolitica(item: any): void {
    this.descargarDesdeHistorialPolitica(item, true);
  } */

 



  private extraerListaDocumentos(response: any): any[] {
    if (Array.isArray(response)) {
      return response;
    }
    if (Array.isArray(response?.archivos)) {
      return response.archivos;
    }
    if (Array.isArray(response?.documentos)) {
      return response.documentos;
    }
    if (Array.isArray(response?.data)) {
      return response.data;
    }
    return [];
  }

  private normalizarCodigoPolitica(codigo: string): string {
    return String(codigo || "")
      .trim()
      .replace(/[^a-zA-Z0-9_-]/g, "_")
      .replace(/_+/g, "_")
      .replace(/^_|_$/g, "");
  }

  private obtenerCarpetaPolitica(codigo: string): string {
    const codigoNormalizado = this.normalizarCodigoPolitica(codigo);
    return codigoNormalizado ? `pesv/politica/${codigoNormalizado}` : `pesv/politica`;
  }

  private construirNombreArchivoDocumentoPoliticaPorCodigo(codigo: string, file: File): string {
    const extension = file.name.split(".").pop()?.toLowerCase() || "bin";
    return `POLITICA_${this.normalizarCodigoPolitica(codigo)}.${extension}`;
  }

  private mapearDocumentoHistorialPolitica(doc: any, politica: any): any {
    const nombreArchivo = doc?.name || doc?.nombre || doc?.archivo || doc?.filename || doc?.fileName || "";
    return {
      id: politica?.id ?? politica?.codigo ?? nombreArchivo,
      codigo: politica?.codigo,
      fecha_designacion: politica?.fecha_designacion,
      fecha_vencimiento: politica?.fecha_vencimiento,
      estado: politica?.estado,
      nombre: nombreArchivo || "Sin nombre",
      tieneDocumento: true,
      nombreArchivo,
      documentoNombre: nombreArchivo,
    };
  }

  cargarHistorialPoliticas(): void {
    this.cargandoHistorial = true;
    this.cargarHistorialPoliticasLegacy();
  }

  private cargarHistorialPoliticasLegacy(): void {
    this.politicaPesvService.getAll().subscribe({
      next: (politicas: any[]) => {
        const lista = Array.isArray(politicas) ? politicas : [];
      
        if (!lista.length) {
          this.historialPoliticas = [];
          this.cargandoHistorial = false;
          return;
        }
        this.historialPoliticas = lista;
        this.cargandoHistorial = false;

       /*  this.digitalesService.listarDocumentos(this.obtenerCarpetaPolitica("")).subscribe({
          next: (respuesta: any) => {
            const documentos = this.extraerListaDocumentos(respuesta);
            const documentosPorVersion = new Map<string, any>();

            documentos.forEach((documento) => {
              const version = this.extraerVersionDesdeDocumentoPolitica(documento);
              if (version && !documentosPorVersion.has(version)) {
                documentosPorVersion.set(version, documento);
              }
            });

            this.historialPoliticas = lista
              .map((politica) => {
                const codigo = this.normalizarCodigoPolitica(politica?.codigo || "");
                const documento = documentosPorVersion.get(codigo);

                return {
                  ...politica,
                  codigo,
                  tieneDocumento: !!documento,
                  documentoNombre:
                    documento?.name ||
                    documento?.nombre ||
                    documento?.archivo ||
                    documento?.filename ||
                    documento?.fileName ||
                    "",
                };
              })
              .sort((a, b) => {
                const aCodigo = String(a?.codigo || "");
                const bCodigo = String(b?.codigo || "");
                return bCodigo.localeCompare(aCodigo);
              });

            this.cargandoHistorial = false;
          },
          error: (err) => {
            console.error("Error cargando documentos de politica:", err);
            this.historialPoliticas = lista
              .map((politica) => ({
                ...politica,
                codigo: this.normalizarCodigoPolitica(politica?.codigo || ""),
                tieneDocumento: false,
                documentoNombre: "",
              }))
              .sort((a, b) => {
                const aCodigo = String(a?.codigo || "");
                const bCodigo = String(b?.codigo || "");
                return bCodigo.localeCompare(aCodigo);
              });
            this.cargandoHistorial = false;
          },
        }); */
      },
      error: (err) => {
        console.error("Error obteniendo politicas:", err);
        this.historialPoliticas = [];
        this.cargandoHistorial = false;
      },
    });
  }


  esPoliticaActiva(politica: any): boolean {
   // console.debug("esPoliticaActiva", { politica });
   return Number(politica?.estado) === 3;
  }

  private obtenerEstadoPolitica(politica: any): string {
    const estadoNombre = [
      politica?.estadoDocumento?.nombre,
      politica?.estado_documento?.nombre,
      politica?.estadoNombre,
      politica?.estado_nombre,
      politica?.estado,
    ]
      .filter((valor) => valor !== null && valor !== undefined && valor !== "")
      .map((valor) => String(valor).trim().toLowerCase());

    if (estadoNombre.some((valor) => valor.includes("borrador"))) {
      return "BORRADOR";
    }

    if (estadoNombre.some((valor) => valor.includes("vigente"))) {
      return "VIGENTE";
    }

    if (estadoNombre.some((valor) => valor.includes("obsolet"))) {
      return "OBSOLETA";
    }

    if (estadoNombre.some((valor) => valor.includes("elimin"))) {
      return "ELIMINADO";
    }

    if (estadoNombre.some((valor) => valor.includes("rechaz"))) {
      return "RECHAZADA";
    }

    const estadoId = Number(
      politica?.estadoDocumento?.id ??
      politica?.estado_documento?.id ??
      politica?.estadoId ??
      politica?.estado_id ??
      politica?.estado
    );

    if ([1, 2].includes(estadoId)) {
      return "BORRADOR";
    }

    if ([3].includes(estadoId)) {
      return "VIGENTE";
    }

    if ([4, 5].includes(estadoId)) {
      return "OBSOLETA";
    }

    return "";
  }

  puedeEditarPolitica(politica: any): boolean {
    return this.obtenerEstadoPolitica(politica) === "BORRADOR";
  }

  private obtenerMensajeNoEditable(politica: any): string {
    switch (this.obtenerEstadoPolitica(politica)) {
      case "VIGENTE":
        return "La política está vigente. Para modificarla debe crear una nueva versión.";
      case "OBSOLETA":
        return "La política está obsoleta. Solo se permite consulta.";
      case "ELIMINADO":
        return "La política está eliminada. Se conserva solo como histórico.";
      case "RECHAZADA":
        return "La política está rechazada y no puede editarse.";
      default:
        return "Solo las políticas en estado BORRADOR pueden editarse.";
    }
  }

  esPoliticaVigente(politica: any): boolean {
    if (!this.esPoliticaActiva(politica)) {
      return false;
    }

    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    const fechaDesignacion = politica?.fecha_designacion ? new Date(politica.fecha_designacion) : null;
    const fechaVencimiento = politica?.fecha_vencimiento ? new Date(politica.fecha_vencimiento) : null;

    if (fechaDesignacion) {
      const inicio = new Date(fechaDesignacion);
      inicio.setHours(0, 0, 0, 0);
      if (inicio > hoy) {
        return false;
      }
    }

    if (fechaVencimiento) {
      const fin = new Date(fechaVencimiento);
      fin.setHours(0, 0, 0, 0);
      if (fin < hoy) {
        return false;
      }
    }

    return true;
  }

  editarPoliticaDesdeHistorial(politica: any): void {
    if (!politica || politica.id == null) {
      this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador de la politica a editar');
      return;
    }

    if (!this.puedeEditarPolitica(politica)) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede editar',
        text: this.obtenerMensajeNoEditable(politica)
      });
      return;
    }

    this.politicaEditando = politica;
    this.politicaEditandoId = politica.id;
    this.politicaCodigoOriginal = this.normalizarCodigoPolitica(politica.codigo || "");
    this.archivoSeleccionadoEditar = null;

    const fechaDesignacion = this.normalizarFechaParaInput(politica.fecha_designacion);
    const fechaVencimiento = this.normalizarFechaParaInput(politica.fecha_vencimiento);

    this.formEditarPolitica.patchValue({
      codigo: politica.codigo || "",
      fecha_designacion: fechaDesignacion,
      fecha_vencimiento: fechaVencimiento,
      estado: politica.estado ?? politica.estadoDocumento?.id ?? 1,
    });
  }

  abrirModalEditarPolitica(template: any): void {
    this.modalEditarPoliticaRef = this.modalService.open(template, { centered: true, size: 'lg' });
    this.modalEditarPoliticaRef.result.finally(() => {
      this.archivoSeleccionadoEditar = null;
      this.formEditarPolitica.reset();
      this.politicaEditandoId = null;
      this.politicaEditando = null;
      this.politicaCodigoOriginal = null;
    });
  }

  private eliminarArchivosPreviosPolitica(nombreCarpeta: string): Promise<void> {
    return new Promise((resolve) => {
      this.digitalesService.listarDocumentos(nombreCarpeta).subscribe({
        next: (respuesta: any) => {
          const documentos = this.extraerListaDocumentos(respuesta);
          const rutasAEliminar = documentos
            .map((doc) => {
              const rutaDirecta = doc?.rutaCompleta || doc?.ruta_completa || doc?.path || doc?.ruta;
              if (typeof rutaDirecta === 'string' && rutaDirecta.trim() !== '') {
                return rutaDirecta;
              }
              const nombreArchivo = doc?.name || doc?.nombre || doc?.archivo || doc?.fileName || doc?.filename;
              if (typeof nombreArchivo === 'string' && nombreArchivo.trim() !== '') {
                return `${nombreCarpeta}/${nombreArchivo}`;
              }
              return '';
            })
            .filter((ruta) => !!ruta && !ruta.endsWith('/'));

          if (rutasAEliminar.length === 0) {
            resolve();
            return;
          }

          let pendientes = rutasAEliminar.length;
          const finalizarSiCorresponde = () => {
            pendientes -= 1;
            if (pendientes <= 0) {
              resolve();
            }
          };

          rutasAEliminar.forEach((ruta) => {
            this.digitalesService.eliminarArchivo(ruta).subscribe({
              next: () => finalizarSiCorresponde(),
              error: (error) => {
                console.warn('Advertencia al eliminar archivo previo de política:', error);
                finalizarSiCorresponde();
              },
            });
          });
        },
        error: (error) => {
          console.warn('Advertencia listando archivos previos de política:', error);
          resolve();
        },
      });
    });
  }

  guardarCambiosPolitica(modal: any): void {
    if (!this.formEditarPolitica.valid) {
      this.formEditarPolitica.markAllAsTouched();
      this.mostrarSwalAccion('warning', 'Validación', 'Completa todos los campos requeridos');
      return;
    }

    if (!this.politicaEditandoId) {
      this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador de la política');
      return;
    }

    const codigo = this.normalizarCodigoPolitica(this.formEditarPolitica.get('codigo')?.value);
    const fechaDesignacion = String(this.formEditarPolitica.get('fecha_designacion')?.value || '').trim();
    const fechaVencimiento = String(this.formEditarPolitica.get('fecha_vencimiento')?.value || '').trim();
    const codigoOriginal = this.politicaCodigoOriginal || "";
    const editarSinCambioDeVersion = !!codigoOriginal && codigo === codigoOriginal;

    if (!codigo || !fechaDesignacion || !fechaVencimiento) {
      this.mostrarSwalAccion('error', 'Error', 'Versión, fecha de designación y fecha de vencimiento son obligatorios');
      return;
    }

    const hoy = this.formatearFechaParaInput(new Date());
    if (fechaDesignacion > hoy) {
      this.mostrarSwalAccion('warning', 'Fecha inválida', 'La fecha de designación no puede ser futura en edición');
      return;
    }

    // Verificar si el código ya existe en otra política
    this.politicaPesvService.getAll().subscribe({
      next: (politicas: any[]) => {
        const politicaExistente = (Array.isArray(politicas) ? politicas : []).find(
          (politica: any) => this.normalizarCodigoPolitica(politica?.codigo || "") === codigo,
        );

        const codigoDuplicado = !!politicaExistente && String(politicaExistente?.id) !== String(this.politicaEditandoId);

        if (codigoDuplicado) {
          this.mostrarSwalAccion('warning', 'Versión duplicada', `La versión ${codigo} ya existe. Cambia la versión para poder guardar.`);
          return;
        }

        this.cargandoEditarPolitica = true;

        const payload = editarSinCambioDeVersion
          ? {
              fecha_designacion: fechaDesignacion,
              fecha_vencimiento: fechaVencimiento,
              estado: this.formEditarPolitica.get('estado')?.value,
            }
          : {
              codigo,
              fecha_designacion: fechaDesignacion,
              fecha_vencimiento: fechaVencimiento,
              estado: this.formEditarPolitica.get('estado')?.value,
            };

        const archivoEditar = this.archivoSeleccionadoEditar;
        const requiereSubidaArchivo = !!archivoEditar;

        const idParaActualizar = this.politicaEditandoId as string | number;
        this.politicaPesvService.update(idParaActualizar, payload).subscribe({
          next: (response) => {
            if (!requiereSubidaArchivo) {
              this.cargandoEditarPolitica = false;
              this.mostrarSwalAccion('success', 'Exito', 'Política actualizada correctamente');
              this.politicaEditandoId = null;
              this.politicaEditando = null;
              this.politicaCodigoOriginal = null;
              this.archivoSeleccionadoEditar = null;
              this.formEditarPolitica.reset();
              this.cargarHistorialPoliticas();
              modal.dismiss();
              return;
            }

            const nombreCarpeta = this.obtenerCarpetaPolitica(codigo);
            const nombreArchivo = archivoEditar ? this.construirNombreArchivoDocumentoPoliticaPorCodigo(codigo, archivoEditar) : "";
            const prefijo = this.archivoDigitalPolitica.prefijo || "POLITICA";
            const idNumerico = Number(this.archivoDigitalPolitica.id || 3);

            // Eliminar archivos previos antes de subir el nuevo
            this.eliminarArchivosPreviosPolitica(nombreCarpeta).then(() => {
              this.digitalesService.subirArchivo(archivoEditar as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.UploadProgress && event.total) {
                    this.progresoSubida = Math.round((100 * event.loaded) / event.total);
                  } else if (event.type === HttpEventType.Response) {
                    this.cargandoEditarPolitica = false;
                    this.mostrarSwalAccion('success', 'Exito', 'Política y documento actualizados correctamente');
                    this.politicaEditandoId = null;
                    this.politicaEditando = null;
                    this.politicaCodigoOriginal = null;
                    this.archivoSeleccionadoEditar = null;
                    this.formEditarPolitica.reset();
                    this.cargarHistorialPoliticas();
                    modal.dismiss();
                  }
                },
                error: () => {
                  this.cargandoEditarPolitica = false;
                  this.mostrarSwalAccion('error', 'Error', 'Se actualizo el registro, pero no se pudo reemplazar el documento.');
                  this.cargarHistorialPoliticas();
                },
              });
            }).catch((err) => {
              console.error('Error eliminando archivos previos, continuando:', err);
              // Continuar con la subida aunque falle la eliminación
              this.digitalesService.subirArchivo(archivoEditar as File, idNumerico, nombreCarpeta, nombreArchivo, prefijo).subscribe({
                next: (event: any) => {
                  if (event.type === HttpEventType.Response) {
                    this.cargandoEditarPolitica = false;
                    this.mostrarSwalAccion('success', 'Exito', 'Política y documento actualizados correctamente');
                    this.politicaEditandoId = null;
                    this.politicaEditando = null;
                    this.politicaCodigoOriginal = null;
                    this.archivoSeleccionadoEditar = null;
                    this.formEditarPolitica.reset();
                    this.cargarHistorialPoliticas();
                    modal.dismiss();
                  }
                },
                error: () => {
                  this.cargandoEditarPolitica = false;
                  this.mostrarSwalAccion('error', 'Error', 'No se pudo reemplazar el documento.');
                },
              });
            });
          },
          error: (err) => {
            this.cargandoEditarPolitica = false;
            this.mostrarSwalAccion('error', 'Error', this.obtenerMensajeError(err, 'No se pudo actualizar la política'));
          },
        });
      },
      error: (err) => {
        this.mostrarSwalAccion('error', 'Error', 'No se pudo verificar la política');
      },
    });
  }

  cambiarEstadoPolitica(politica: any, activar: boolean): void {
    if (!politica || politica.id == null) {
      this.mostrarSwalAccion('error', 'Error', 'No se encontro el identificador de la politica');
      return;
    }

    const yaEnEstadoObjetivo = activar ? this.esPoliticaActiva(politica) : !this.esPoliticaActiva(politica);
    if (yaEnEstadoObjetivo) {
      this.mostrarSwalAccion('info', 'Sin cambios', activar ? 'La politica ya esta activa' : 'La politica ya esta inactiva');
      return;
    }

    Swal.fire({
      title: 'Confirmar accion',
      text: activar ? '¿Deseas activar esta politica?' : '¿Deseas inactivar esta politica?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si',
      cancelButtonText: 'No',
      confirmButtonColor: '#0d6efd',
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      const request$ = activar
        ? this.politicaPesvService.activar(politica.id)
        : this.politicaPesvService.inactivar(politica.id);

      request$.subscribe({
        next: () => {
          politica.estado = activar ? 1 : 0;
          politica.activo = activar;
          this.mostrarSwalAccion('success', 'Exito', activar ? 'Politica activada correctamente' : 'Politica inactivada correctamente');
          this.cargarHistorialPoliticas();
        },
        error: (err) => {
          this.mostrarSwalAccion('error', 'Error', this.obtenerMensajeError(err, activar ? 'No se pudo activar la politica' : 'No se pudo inactivar la politica'));
        },
      });
    });
  }

  visualizarPolitica(id: number | string): void {
    const nombreDocumento =
      this.nombreDocumentoPoliticaActivo?.nombre_documento ||
      this.nombreDocumentoPoliticaActivo?.nombre ||
      "Política de Seguridad Vial";

    this.cargando = true;

    this.versionesDocumentoService
      .descargarDocumentoVigenteporNombre(nombreDocumento, "pdf")
      .subscribe({
        next: (response: any) => {
          this.cargando = false;

          const blob = response?.body || response;
          if (!blob || blob.size === 0) {
            Swal.fire(
              "Información",
              "No se encontró un documento vigente para Política.",
              "info",
            );
            return;
          }

          const url = URL.createObjectURL(blob);
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.tabActivo = 1;
          Swal.fire(
            "Éxito",
            "Documento cargado. Cambiando a visualización...",
            "success",
          );
        },
        error: (err) => {
          this.cargando = false;
          Swal.fire(
            "Error",
            this.obtenerMensajeError(err, "No se pudo cargar el documento"),
            "error",
          );
          console.error("Error:", err);
        },
      });
  }

  private obtenerMensajeError(err: any, porDefecto: string): string {
    const mensaje = err?.error?.message || err?.error?.error || err?.message || porDefecto;

    if (typeof mensaje !== 'string') {
      return porDefecto;
    }

    if (mensaje.toLowerCase().startsWith('http failure response for')) {
      return porDefecto;
    }

    return mensaje;
  }

  private mostrarSwalAccion(
    icon: "success" | "error" | "warning" | "info" | "question",
    titulo: string,
    texto?: string,
  ): void {
    Swal.fire({
      icon,
      title: titulo,
      text: texto,
      confirmButtonColor: "#0d6efd",
    });
  }



  // ===========================
  // Métodos para cargar datos
  // ===========================
  cargarDataAdmin(): void {
    this.administracionesService.obtenerTodas().subscribe({
      next: (res: any) => {
        const lista = Array.isArray(res)
          ? res
          : Array.isArray(res?.administraciones)
            ? res.administraciones
            : [];

        this.administraciones = lista;
        if (this.administraciones.length > 0) {
          this.empresaNit = this.administraciones[0].nit?.toString() || null;
          console.log('🏢 NIT de la empresa:', this.empresaNit);
        }
      },
      error: (err: any) => {
        console.error('❌ Error al cargar administraciones:', err);
      }
    });
  }

  // ===========================
  // Métodos para manejo de archivos
  // ===========================
  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension && this.formatosPermitidosPolitica.includes(extension)) {
        this.archivoSeleccionado = file;
        this.archivoDigitalPolitica.file = file;
        this.estadoSubida = "";
        this.mensajeSubida = "";
        console.log('📄 Archivo seleccionado:', file.name);
        this.mostrarSwalAccion('success', 'Archivo cargado', `Se selecciono ${file.name}`);
      } else {
        Swal.fire('Error', `Solo se permiten: ${this.formatosPermitidosPoliticaTexto || '.doc, .docx'}`, 'error');
      }
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension && this.formatosPermitidosPolitica.includes(extension)) {
        this.archivoSeleccionado = file;
        this.archivoDigitalPolitica.file = file;
        this.estadoSubida = "";
        this.mensajeSubida = "";
        console.log('📄 Archivo arrastrado:', file.name);
        this.mostrarSwalAccion('success', 'Archivo cargado', `Se selecciono ${file.name}`);
      } else {
        Swal.fire('Error', `Solo se permiten: ${this.formatosPermitidosPoliticaTexto || '.doc, .docx'}`, 'error');
      }
    }
  }

  eliminarArchivo(): void {


    this.archivoSeleccionado = null;
    this.archivoDigitalPolitica.file = null;
    this.estadoSubida = "";
    this.mensajeSubida = "";
    this.progresoSubida = 0;
  }

  onFileChangeEditar(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const extension = file.name.split('.').pop()?.toLowerCase();
      if (extension && this.formatosPermitidosPolitica.includes(extension)) {
        this.archivoSeleccionadoEditar = file;
        console.log('📄 Archivo seleccionado para editar:', file.name);
      } else {
        Swal.fire('Validación', `Solo se permiten: ${this.formatosPermitidosPoliticaTexto || '.pdf, .doc, .docx'}`, 'warning');
        event.target.value = '';
        this.archivoSeleccionadoEditar = null;
      }
    }
  }

  eliminarArchivoEditar(): void {
    this.archivoSeleccionadoEditar = null;
  }

  subirDocumento(): void {
    if (!this.formPolitica.valid) {
      this.formPolitica.markAllAsTouched();
      Swal.fire('Validación', 'Completa la versión y las fechas de la política', 'warning');
      return;
    }

    const codigo = this.normalizarCodigoPolitica(this.formPolitica.get('codigo')?.value);
    const fechaDesignacion = String(this.formPolitica.get('fecha_designacion')?.value || '').trim();
    const fechaVencimiento = String(this.formPolitica.get('fecha_vencimiento')?.value || '').trim();
    const motivo_cambio = String(this.formPolitica.get('motivo_cambio')?.value || '').trim();

    if (!codigo || !fechaDesignacion || !fechaVencimiento) {
      Swal.fire('Error', 'Versión, fecha de designación y fecha de vencimiento son obligatorios', 'error');
      return;
    }

    this.estadoSubida = "subiendo";
    this.progresoSubida = 0;
    this.mensajeSubida = "";
    this.mostrarSwalAccion('info', 'Procesando', 'Guardando politica y documento...');

    const archivoSeleccionado = this.archivoSeleccionado;
    // ✅ SIEMPRE incluir el NIT administrativo en la ruta de Digitales PESV
    const nit = this.empresaNit || 'nit';
    const nombreCarpeta = `${nit}/pesv/cargados/${codigo}`;
    const nombreArchivo = archivoSeleccionado
      ? this.construirNombreArchivoDocumentoPoliticaPorCodigo(codigo, archivoSeleccionado)
      : "";
    const prefijo = this.archivoDigitalPolitica.prefijo || 'PSV';
    const id = Number(this.archivoDigitalPolitica.id || 3);

    const payload = {
      codigo,
      fecha_designacion: fechaDesignacion,
      fecha_vencimiento: fechaVencimiento,
      motivo_cambio: motivo_cambio || "",
      estado: 1,
    };

    const editandoId = this.politicaEditandoId;

    this.politicaPesvService.getAll().subscribe({
      next: (politicas: any[]) => {
        const politicaExistente = (Array.isArray(politicas) ? politicas : []).find(
          (politica: any) => this.normalizarCodigoPolitica(politica?.codigo || "") === codigo,
        );

        const codigoDuplicado = !!politicaExistente && String(politicaExistente?.id) !== String(editandoId ?? "");

        if (codigoDuplicado) {
          this.estadoSubida = "error";
          this.progresoSubida = 0;
          this.mensajeSubida = `La versión ${codigo} ya existe. Cambia la versión para poder guardar.`;
          this.mostrarSwalAccion('warning', 'Versión duplicada', this.mensajeSubida);
          return;
        }

        const guardarPolitica = editandoId
          ? this.politicaPesvService.update(editandoId, payload)
          : this.politicaPesvService.create(payload);

        guardarPolitica.subscribe({
          next: (politicaGuardada: any) => {
            const formularioGuardado = !!politicaGuardada;
            if (!formularioGuardado) {
              this.estadoSubida = "error";
              this.mensajeSubida = "No se pudo confirmar el guardado del formulario";
              this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
              return;
            }

            const idPolitica = politicaGuardada?.id ?? editandoId ?? codigo;

            console.log('📤 Guardando política y subiendo documento:', {
              carpeta: nombreCarpeta,
              nombre: nombreArchivo,
              codigo,
              politica: idPolitica,
              prefijo: prefijo
            });

            if (!archivoSeleccionado) {
              if (editandoId) {
                this.estadoSubida = "exito";
                this.mensajeSubida = "Política actualizada correctamente";
                this.mostrarSwalAccion('success', 'Exito', this.mensajeSubida);
                this.politicaEditandoId = null;
                this.formPolitica.reset();
                this.eliminarArchivo();
                this.cargarHistorialPoliticas();
                return;
              }

              const nombreArchivoDefault = `POLITICA_${codigo}_PESV.pdf`;
              this.formatosService.generarDocumentoPdf(this.formatoPoliticaId, {
                version: this.formPolitica.get("codigo")?.value || this.politicaCodigoOriginal || "",
                fecha: this.formPolitica.get("fecha_designacion")?.value || "",
                fechaPublicacion: this.formPolitica.get("fecha_designacion")?.value || "",
              }).subscribe({
                next: (blobDefault: Blob) => {
                  // Solo se genera y sube el documento despues de guardar el formulario.
                  const archivoDefault = new File(
                    [blobDefault],
                    nombreArchivoDefault,
                    {
                      type: "application/pdf",
                    },
                  );

                  this.subirArchivoPolitica(
                    archivoDefault,
                    id,
                    nombreCarpeta,
                    nombreArchivoDefault,
                    prefijo,
                    "Política guardada",
                  );
                },
                error: (err: any) => {
                  this.estadoSubida = "error";
                  this.mensajeSubida = "La política se guardó, pero falló la generación del documento ";
                  console.error('❌ Error al generar documento de política:', err);
                  this.mostrarSwalAccion('warning', 'Politica guardada con observacion', this.mensajeSubida);
                  setTimeout(() => {
                    this.cargarHistorialPoliticas();
                  }, 1200);
                },
              });
              return;
            }

            this.subirArchivoPolitica(
              archivoSeleccionado,
              id,
              nombreCarpeta,
              nombreArchivo,
              prefijo,
              editandoId ? "Política actualizada y documento subido correctamente" : "Política guardada y documento subido correctamente",
            );
          },
          error: (err: any) => {
            this.estadoSubida = "error";
            this.mensajeSubida = this.obtenerMensajeError(err, 'Error al guardar la política');
            console.error('❌ Error al guardar política:', err);
            this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
          }
        });
      },
      error: (err: any) => {
        this.estadoSubida = "error";
        this.mensajeSubida = this.obtenerMensajeError(err, "No se pudo validar la política antes de guardar");
        console.error('❌ Error consultando políticas antes de guardar:', err);
        this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
      },
    });
  }

  private subirArchivoPolitica(
    archivo: File,
    idDigital: number,
    carpeta: string,
    nombreArchivo: string,
    prefijo: string,
    mensajeExito: string,
  ): void {
    this.digitalesService.subirArchivo(
      archivo,
      idDigital,
      carpeta,
      nombreArchivo,
      prefijo
    ).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          this.progresoSubida = Math.round((100 * event.loaded) / event.total);
          console.log(`📊 Progreso: ${this.progresoSubida}%`);
        } else if (event.type === HttpEventType.Response) {
          this.estadoSubida = "exito";
          this.mensajeSubida = mensajeExito;
          console.log('✅ Documento subido:', event.body);
          this.mostrarSwalAccion('success', 'Exito', mensajeExito);
          this.politicaEditandoId = null;

          setTimeout(() => {
            this.formPolitica.reset();
            this.eliminarArchivo();
            this.cargarHistorialPoliticas();
          }, 2000);
        }
      },
      error: (err: any) => {
        this.estadoSubida = "error";
        this.mensajeSubida = this.obtenerMensajeError(err, 'Error al subir el documento');
        console.error('❌ Error al subir:', err);
        this.mostrarSwalAccion('error', 'Error', this.mensajeSubida);
      }
    });
  }

  // ===========================
  // Métodos para documentos GCP
  // ===========================
  visualizarDocumentoGCP(nombreArchivo: string): void {
    if (!nombreArchivo) {
      Swal.fire('Error', 'No se especificó el nombre del archivo', 'error');
      return;
    }

    this.cargando = true;
    console.log('👁️ Descargando documento de GCP para visualizar:', nombreArchivo);

    const descargarDesdeDigitales = () => {
      this.digitalesService.descargarDocumento3(this.obtenerCarpetaDigitalPolitica(), nombreArchivo).subscribe({
        next: (blob: Blob) => {
          this.cargando = false;
          const url = URL.createObjectURL(blob);
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
          this.tabActivo = 1;
          console.log('✅ Documento cargado desde digitales para visualización');
        },
        error: (err: any) => {
          this.cargando = false;
          Swal.fire('Error', this.obtenerMensajeError(err, 'No se pudo cargar el documento desde GCP'), 'error');
          console.error('❌ Error al visualizar documento GCP:', err);
        }
      });
    };

    if (!this.empresaNit) {
      descargarDesdeDigitales();
      return;
    }

    this.digitalesService.descargarDocumentoPesvCargado(this.empresaNit, this.obtenerCarpetaCargadosPolitica(), nombreArchivo).subscribe({
      next: (blob: Blob) => {
        this.cargando = false;
        const url = URL.createObjectURL(blob);
        this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.tabActivo = 1;
        console.log('✅ Documento cargado desde cargados para visualización');
      },
      error: () => {
        descargarDesdeDigitales();
      }
    });
  }

 

    previsualizarVersion(id: any): void {
    this.versionPreview = true;
    console.log(id);
    this.descargarVersion(id, () => {
      this.versionPreview = false;
    });
  }

  //Descargar//

  descargarVersion(
    id: any,
    onFinish?: () => void,
    tipoSalida?: "pdf" | "word",
  ): void {
    // ✅ Validar que tenemos al menos documento y un identificador de versión
    const tieneIdentificadorVersion = !!(
      id?.numero_version ||
      id?.id ||
      id?.version_id
    );
    if (!this.documento_id || !tieneIdentificadorVersion) {
      Swal.fire({
        icon: "warning",
        title: "Información incompleta",
        text: "No se puede descargar. Faltan datos requeridos del documento o la versión.",
        confirmButtonText: "Aceptar",
      });
      if (!this.versionData.numero_version && !id?.id && !id?.version_id) {
      }

      return;
    }

    const nombreDocumentoId = this.obtenerNombreDocumentoId({
      nombre_id: this.formData?.nombre,
      nombre: this.formData?.nombre,
    });
    const esPoliticaPesv = nombreDocumentoId === 4;

    const versionId = id?.id || id?.version_id;

    if (!versionId) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se encontró el ID de la versión.",
        confirmButtonText: "Aceptar",
      });
      return;
    }

    this.iniciarDescargaCancelable(
      "Descargando...",
      "Por favor espera mientras se descarga el documento.",
    );

    this.descargaActivaSub = this.digitalesService
      .descargarArchivoPorVersionId(versionId, tipoSalida)
      .subscribe({
        next: (response: any) => {
          if (this.descargaCancelada) {
            return;
          }

          this.cerrarDescargaCancelable();

          const blob: Blob = response?.body || response;

          const contentDisposition =
            response?.headers?.get("content-disposition") || "";

          const nombreHeaderMatch =
            /filename\*=UTF-8''([^;]+)|filename=\"?([^\";]+)\"?/i.exec(
              contentDisposition,
            );

          let nombreArchivo = decodeURIComponent(
            (nombreHeaderMatch?.[1] || nombreHeaderMatch?.[2] || "")
              .replace(/\"/g, "")
              .trim(),
          );

          if (!nombreArchivo) {
            nombreArchivo = `DOCUMENTO_VERSION_${versionId}`;
          }

          if (this.versionPreview) {
            this.abrirBlob(nombreArchivo, blob);
            onFinish?.();
          } else {
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = url;
            a.download = nombreArchivo;

            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            onFinish?.();
          }
        },
        error: (error) => {
          console.error("❌ Error descargando versión:", error);

          this.cerrarDescargaCancelable();

          Swal.fire({
            icon: "error",
            title: "Error al descargar",
            text: "No se pudo descargar el documento.",
            confirmButtonText: "Aceptar",
          });
        },
      });

    return;
  }

    private normalizarSegmentoRuta(valor: string): string {
    return (valor || "")
      .toString()
      .replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ_-]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

    private obtenerNombreDocumentoId(payload: any): number | null {
      const valor = payload?.nombre_id ?? payload?.nombre?.id ?? payload?.nombre;
      if (valor === null || valor === undefined || valor === "") return null;
      const id = typeof valor === "string" ? parseInt(valor, 10) : Number(valor);
      return Number.isNaN(id) ? null : id;
    }

    private construirPayloadVersionSeleccionada(version: any, contexto: any): any {
      return {
        versionId: version?.id ?? version?.version_id ?? null,
        numero_version: version?.numero_version ?? version?.version ?? null,
        ...contexto,
      };
    }

    private obtenerExtensionDesdeUrl(url: string): string {
      try {
        const ruta = new URL(url);
        const archivo = ruta.pathname.split("/").pop() || "";
        const extension = archivo.includes(".") ? (archivo.split(".").pop() || "").toLowerCase() : "";
        return extension || "bin";
      } catch {
        const archivo = (url || "").split("/").pop() || "";
        const extension = archivo.includes(".") ? (archivo.split(".").pop() || "").toLowerCase() : "";
        return extension || "bin";
      }
    }

    private iniciarDescargaCancelable(titulo: string, texto: string): void {
      this.descargaCancelada = false;
      this.descargaActivaSub?.unsubscribe();
      this.descargaActivaSub = null;

      Swal.fire({
        title: titulo,
        text: texto,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        didOpen: () => {
          Swal.showLoading();
        },
      }).then((result: any) => {
        if (result.dismiss === Swal.DismissReason.cancel) {
          this.descargaCancelada = true;
          this.descargaActivaSub?.unsubscribe();
          this.descargaActivaSub = null;
        }
      });
    }

    private cerrarDescargaCancelable(): void {
      this.descargaActivaSub = null;
      if (Swal.isVisible()) {
        Swal.close();
      }
    }

    private abrirBlob(nombreArchivo: string, blob: Blob): void {
      if (this.descargaCancelada) {
        return;
      }

      this.cerrarDescargaCancelable();

      const objectUrl = window.URL.createObjectURL(blob);
      // Si es PDF preferimos abrir en nueva pestaña para mejor experiencia
      const tipo = (blob && blob.type) ? String(blob.type).toLowerCase() : "";
      if (tipo.includes("pdf")) {
        window.open(objectUrl, "_blank");
        // dejamos que el navegador maneje la pestaña; liberamos URL más tarde
        setTimeout(() => {
          try { window.URL.revokeObjectURL(objectUrl); } catch (e) { /* ignore */ }
        }, 2000);
        return;
      }

      const a = document.createElement("a");
      a.href = objectUrl;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(objectUrl);
    }

      abrirmodalCrear(): void {
    if (this.tienePoliticaVigente) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede crear una nueva política',
        text: 'Ya existe una política de seguridad vial vigente. Inactive la actual o espere a que venza para crear una nueva.'
      });
      return;
    }

    this.modalCrearPoliticaRef = this.modalService.open(
      this.modalCrearPolitica,
      {
        centered: true,
        size: 'lg'
      }
    );

    this.modalCrearPoliticaRef.result.finally(() => {
      // Limpiar formulario si es necesario
      // this.formCrearPolitica.reset();
    });
  }
    
  
    /**
     * Manejar selección de archivo PDF
     */
    onPdfFileSelected(event: any): void {
      const file = event?.target?.files?.[0];
      if (!file) {
        return;
      }
  
      this.asignarPdfActaSeleccionado(file);
      event.target.value = "";
    }
  
    onDragOverPdf(event: DragEvent): void {
      event.preventDefault();
      const target = event.currentTarget as HTMLElement;
      target.classList.add("drag-over");
    }
  
    onDragLeavePdf(event: DragEvent): void {
      event.preventDefault();
      const target = event.currentTarget as HTMLElement;
      target.classList.remove("drag-over");
    }
  
    onDropPdfActa(event: DragEvent): void {
      event.preventDefault();
      const target = event.currentTarget as HTMLElement;
      target.classList.remove("drag-over");
  
      const file = event.dataTransfer?.files?.[0];
      if (!file) {
        return;
      }
  
      this.asignarPdfActaSeleccionado(file);
      event.dataTransfer?.clearData();
    }
  
  removePdfActaSeleccionado(): void {

    this.pdfFileSelected = null;

    this.frmPoliticaPesv.patchValue({
      soporte: null
    });

    this.frmPoliticaPesv.get('soporte')?.updateValueAndValidity();
  }
  private asignarPdfActaSeleccionado(file: File): void {

  const extension = file.name.split('.').pop()?.toLowerCase() || '';

  if (extension !== 'pdf') {
    Swal.fire("Error", "Solo se permiten archivos PDF", "error");
    return;
  }

  const maxSize = 10 * 1024 * 1024;

  if (file.size > maxSize) {
    Swal.fire("Error", "El archivo no debe superar los 10MB", "error");
    return;
  }

  this.pdfFileSelected = file;

  // 👇 IMPORTANTE: actualizar el FormGroup
  this.frmPoliticaPesv.patchValue({
    soporte: file
  });

  this.frmPoliticaPesv.get('soporte')?.updateValueAndValidity();

  console.log('Soporte agregado:', this.frmPoliticaPesv.value);
}

      formatFileSize(bytes: number): string {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  }

  calcularVencimiento(): void {

  const fechaDesignacion = this.frmPoliticaPesv.get('fecha_designacion')?.value;

  if (!fechaDesignacion) {
    return;
  }

  const fecha = new Date(fechaDesignacion);

  fecha.setFullYear(fecha.getFullYear() + 3);

  const fechaVencimiento = fecha.toISOString().split('T')[0];

  this.frmPoliticaPesv.patchValue({
    fecha_vencimiento: fechaVencimiento
  });


 

  }

  guardarPolitica(): void {
    if (this.tienePoliticaVigente) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede guardar',
        text: 'Ya existe una política de seguridad vial vigente. Inactive la actual o espere a que venza para crear una nueva.'
      });
      return;
    }

 //   console.log("click");
  if (this.frmPoliticaPesv.invalid) {

    this.frmPoliticaPesv.markAllAsTouched();

    Swal.fire({
      icon: 'warning',
      title: 'Campos requeridos',
      text: 'Debe completar toda la información.'
    });

    return;
  }

  const politica = {
    codigo: this.frmPoliticaPesv.value.codigo,
    version: this.frmPoliticaPesv.value.version,
    fecha_designacion: this.frmPoliticaPesv.value.fecha_designacion,
    fecha_vencimiento: this.frmPoliticaPesv.value.fecha_vencimiento,
    estado: this.frmPoliticaPesv.value.estado,
    motivo_creacion: this.frmPoliticaPesv.value.motivo_creacion,
    soporte:this.frmPoliticaPesv.value.soporte
  };

  // console.log(politica);
   
   Swal.fire({
    title: 'Guardando política PESV...',
    text: 'Espere un momento',
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    }
  }); 

 

this.politicaPesvService.create(politica).subscribe({
  next: (resp: any) => {
    console.log('Respuesta backend:', resp);
    Swal.close();

    if (resp?.codigo === 0 && resp?.data?.id) {
      const politicaGuardada = resp.data;
      const mensaje = resp.message || 'Política PESV registrada correctamente';

      if (politica.soporte) {
        this.subirArchivoPolitica(
          politica.soporte,
          politicaGuardada.id,
          `${this.empresaNit}/pesv/documental/politica/${politicaGuardada.codigo}`,
          `POLITICA_${politicaGuardada.codigo}_PESV.pdf`,
          'PSV',
          'Política y documento subidos correctamente'
        );
      } else {
        Swal.fire({
          icon: 'success',
          title: 'Éxito',
          text: mensaje
        });
      }

      this.frmPoliticaPesv.reset({
        version: '1.0',
        estado: 1,
        motivo_creacion: ''
      });

      this.pdfFileSelected = null;
      this.modalCrearPoliticaRef?.close();

      this.cargarHistorialPoliticasLegacy();

    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: resp?.message || 'No fue posible registrar la política.'
      });
    }
  },

  error: (error) => {
    Swal.close();

    const mensaje =
      error?.error?.error ||
      error?.error?.message ||
      'Error inesperado al guardar la política PESV.';

    Swal.fire({
      icon: 'error',
      title: 'No se pudo guardar',
      text: mensaje
    });
  }
});


}

getEstadoDocumento(): void {

  this.estadoDocumentosService.getAllEstados()
    .subscribe({

      next: (resp: any) => {

      //  console.log('Estados:', resp);
        this.estadosPolitica = resp;
        
      },

      error: (error) => {

        console.error(error);

        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No fue posible cargar los estados del documento.'
        });

      }

    });

}

 visualizarPDF(politica: any): void {
    //
        if (!politica.codigo) {
          Swal.fire("Error", "No se puede visualizar sin ID", "error");
          return;
        }
        Swal.fire({
          title: "Confirmar visualización",
          text: "¿Deseas visualizar el documento: Acta Comité PESV?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Visualizar",
          cancelButtonText: "Cancelar",
        }).then((result) => {
          if (!result.isConfirmed) {
            return;
          }
    
         
          if (!this.empresaNit) {
            Swal.close();
            Swal.fire(
              "Error",
              "No se pudo obtener el NIT de la empresa para visualizar el documento.",
              "error",
            );
            return;
          }
    
          const rutaPolitica = `${this.empresaNit}/pesv/documental/politica/${politica.codigo}/${politica.id}/PSV_documental.pdf`;
    
          this.gpcGoogle.getSignedUrlFiles(rutaPolitica).subscribe({
            next: (resp) => {
              Swal.close();
              if (!resp?.url) {
                
                Swal.fire(
                  "Error",
                  "No se pudo obtener la URL del documento de la política PESV.",
                  "error",
                );
                return;
              }
    
              this.googleStoragePreview.open(resp.url, "Política PESV");
             
            },
            error: (err) => {
              
              Swal.close();
              console.error(
                "❌ Error al obtener la URL del documento de la política PESV.",
                err,
              );
              Swal.fire(
                "Error",
                "No se pudo obtener la URL del documento de la política PESV.",
                "error",
              );
            },
          });
    
    
        
    
          
        });
   }

  descargarDocumentoPolitica(politica: any): void {
   // console.log('Descargando política:', politica);
          if (!politica.codigo) {
            Swal.fire("Error", "No se puede descargar sin ID", "error");
            return;
          }
      
          const id = Number(politica.id);
          if (Number.isNaN(id)) {
            Swal.fire("Error", "ID de comité inválido.", "error");
            return;
          }
      
        
          Swal.fire({
            title: "Descargando...",
            text: "Por favor espera mientras se descarga el documento.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
      
          const fileName = `POLITICA_SEGURIDAD_VIAL_PESV_${id}.pdf`;
           const descargarConUrl = (url: string) => {
              Swal.close();
              
              this.descargarDesdeUrlFirmada(url, fileName);
            };
        
          
      
          if (!this.empresaNit) {
            Swal.close();
            
            Swal.fire(
              "Error",
              "No se pudo obtener el NIT de la empresa para descargar el documento.",
              "error",
            );
            return;
          }
      
          const rutaPolitica = `${this.empresaNit}/pesv/documental/politica/${politica.codigo}/${politica.id}/PSV_documental.pdf`;
       
          this.gpcGoogle.getSignedUrlFiles(rutaPolitica).subscribe({
            next: (resp) => {
             
              if (!resp?.url) {
               // this.descargandoLiderId = null;
                Swal.fire(
                  "Error",
                  "No se pudo obtener la URL firmada del documento.",
                  "error",
                );
                return;
              }
      
              descargarConUrl(resp.url);
               Swal.close();
            },
            error: (err) => {
             // this.descargandoLiderId = null;
              Swal.close();
              console.error(
                "❌ Error al obtener la URL firmada del documento del líder PESV.",
                err,
              );
              Swal.fire(
                "Error",
                "No se pudo obtener la URL firmada del documento.",
                "error",
              );
            },
          });
      }

      private descargarDesdeUrlFirmada(url: string, fileName: string): void {
          fetch(url)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Error al descargar archivo: ${response.status}`);
              }
              return response.blob();
            })
            .then((blob) => {
              const objectUrl = window.URL.createObjectURL(blob);
              const enlace = document.createElement("a");
              enlace.href = objectUrl;
              enlace.download = fileName;
              enlace.style.display = "none";
              document.body.appendChild(enlace);
              enlace.click();
              document.body.removeChild(enlace);
              window.URL.revokeObjectURL(objectUrl);
            })
            .catch((error) => {
              console.error("Error al descargar URL firmada:", error);
              Swal.fire("Error", "No se pudo descargar el documento.", "error");
            });
        }
}